
export enum TipoArquivo {
  TEXT_PLAIN = 'TEXT_PLAIN',
  TEXT_HTML = 'TEXT_HTML',
  TEXT_RICHTEXT = 'TEXT_RICHTEXT',
  APPLICATION_PDF = 'APPLICATION_PDF',
  APPLICATION_ODT = 'APPLICATION_ODT',
  APPLICATION_DOC = 'APPLICATION_DOC',
  APPLICATION_DOCX = 'APPLICATION_DOCX',
  APPLICATION_KML = 'APPLICATION_KML',
  IMAGE_PNG = 'IMAGE_PNG',
  IMAGE_BMP = 'IMAGE_BMP',
  IMAGE_JPEG = 'IMAGE_JPEG',
  IMAGE_GIF = 'IMAGE_GIF',
  IMAGE_TIFF = 'IMAGE_TIFF',
  IMAGE_SVG_XML = 'IMAGE_SVG_XML',
  NAO_IDENTIFICADO = 'NAO_IDENTIFICADO'
}
